// src/universal/error-boundary/app-error.ts
var AppError = class extends Error {
  constructor(message, errorMessage, canRetry) {
    super(message);
    this.errorMessage = errorMessage;
    this.canRetry = canRetry;
    this.name = "AppError";
  }
};

export { AppError };
//# sourceMappingURL=chunk-LXZM66LA.mjs.map
//# sourceMappingURL=chunk-LXZM66LA.mjs.map